<template>
  <div class="container pap-form">
    <AlertCard
      v-if="showSendResult"
      :type="resultType"
      :header="resultHeader"
      :message="resultMessage"
    />

    <AlertCard
      v-if="showContactServiceInactive"
      type="error"
      header="Oops..."
      message="The contact service is temporarily inactive. Please try again later."
    />

    <div v-if="showForm" class="card">
      <FormTitle title="Contact Us" iconclass="far fa-envelope mr-2" />
      <div class="card-body">
        <b-form novalidate @submit.prevent="doSend">
          <p class="pap-form__text">
            Have a question about Pixapup? Need tech support or wish to ask
            about a problem you're having with the app?
          </p>
          <p class="pap-form__text">Or just wanna say "Hi"? =)</p>
          <p class="pap-form__text">
            Let us know by sending a message here. We'll get back to you as soon
            as we can (usually within 24 hours)!
          </p>
          <!-- -------------------------------- Subject  -->
          <b-form-group
            id="subject-group"
            label="Subject"
            label-for="subject"
            label-class="label-bold"
            :invalid-feedback="form.subject.errorMsg"
            :state="form.subject.valid"
          >
            <b-form-input
              id="subject"
              :maxlength="fieldMaxLength('subject')"
              placeholder="Subject"
              @input="fieldOnInput('subject')"
              v-model="form.subject.value"
              :state="form.subject.valid"
              trim
            ></b-form-input>
          </b-form-group>

          <!-- -------------------------------- Message  -->
          <b-form-group
            id="message-group"
            label="Message"
            label-for="message"
            label-class="label-bold"
            :invalid-feedback="form.message.errorMsg"
            :state="form.message.valid"
          >
            <p class="text-primary text-smaller-1 m-2">
              # Characters: {{ messageLength }} /
              {{ fieldMaxLength('message') }}
            </p>
            <b-form-textarea
              id="message"
              placeholder="Your message..."
              rows="7"
              :maxlength="fieldMaxLength('message')"
              @input="fieldOnInput('message')"
              v-model="form.message.value"
              :state="form.message.valid"
            ></b-form-textarea>
          </b-form-group>

          <p class="text-primary text-smaller-1 font-weight-bold mt-2 mb-0">
            We will reply to your Login Email address:
          </p>
          <p class="text-primary text-smaller-1">
            {{ authUser.email }}
          </p>

          <!-- -------------------------- End of input fields -->

          <FormErrorAlert
            :showAlert="showFormActionError"
            :msg="formErrorMsg"
          />

          <b-overlay
            :show="processingMessage"
            rounded
            opacity="0.2"
            spinner-small
            spinner-variant="white"
            classxx="d-inline-block"
          >
            <button
              @click="setSubmitted"
              type="submit"
              class="btn btn-block btn-submit pap-form__btn"
            >
              Send
            </button>
          </b-overlay>
        </b-form>
      </div>
      <!-- end card-body -->
    </div>
    <!-- end card -->
  </div>
</template>

<script>
console.log(Math.random());
import AlertCard from '@/components/notifications/AlertCard';
import FormTitle from '@/components/form/FormTitle.vue';
import FormErrorAlert from '@/components/form/FormErrorAlert.vue';
import { Message } from '@/models/Message';

import { mapGetters } from 'vuex';

export default {
  name: 'PageContact',
  components: {
    AlertCard,
    FormTitle,
    FormErrorAlert,
  },
  data: function () {
    return {
      processingMessage: false,
      showSendResult: false, // Result of form submission: After submitting, show the alert card with result message (success/fail); hide alert card otherwise
      resultType: '',
      resultSuccessMsg: 'Your message was sent. We will reply to you soon!',
      resultErrorMsg: '',

      // Form data
      form: {
        subject: {
          value: '',
          valid: null,
          errorMsg: '',
        },
        message: {
          value: '',
          valid: null,
          errorMsg: '',
        },
      },

      // the message obj created in validation when form submitted
      message: null,

      // Text of any overall form error, e.g. validation error, submission result error, etc.
      formErrorMsg:
        'Ooops! Please correct the errors shown in the form above, then click Send again.',

      // Form validation: true: Every field has a valid value; false: At least one field has an invalid value
      formValid: false,

      // Form submission result: Result of form submission (when validated).
      // true: Result of submitted form action was an error; false: Initial state - no error (since form
      // not submitted yet); methods can "reset" this to false to simulate initial state any time after a
      // form submission.
      // formError: false,

      // Flag: true: Form submit button was clicked; false: Reset to primitive state, i.e. form not submitted
      formSubmitted: false,
    };
  },
  computed: {
    ...mapGetters('auth', ['authUser']),
    ...mapGetters(['contactActive']),

    showContactServiceInactive: function () {
      return !this.contactActive;
    },
    showForm: function () {
      // return !this.showSendResult;
      return !this.showSendResult && !this.showContactServiceInactive;
    },
    showFormActionError: function () {
      return (this.formSubmitted && !this.formValid) || this.formError;
    },
    messageLength: function () {
      return this.form.message.value.length;
    },
    resultHeader: function () {
      if (this.resultType === 'success') {
        return 'Success!';
      }
      if (this.resultType === 'error') {
        return 'There was a problem...';
      }
      return '';
    },
    resultMessage: function () {
      return this.resultErrorMsg ? this.resultErrorMsg : this.resultSuccessMsg;
    },
  },
  methods: {
    setSubmitted: function () {
      this.formSubmitted = true;
    },
    resetSubmitted: function () {
      this.formSubmitted = false;
    },

    fieldMaxLength: function (fieldName) {
      return Message.getPropTruncateLength(fieldName) || 50;
    },

    handleMessage: function () {
      console.log('hello message');
    },
    // For given field fieldName, on input to the field, i.e. when the value changes, reset the
    // form state to its primitive/original state in terms of form error alerts, form field error alerts, etc.
    fieldOnInput: function (fieldName) {
      this.resetSubmitted(); // Reset 'form submitted' flag to false, i.e. "starting over" as tho form was never submitted.
      // this.formError = false;
      if (this.form[fieldName].valid === false) {
        this.form[fieldName].valid = null; // Set to null to not show validation state feedback on the field, i.e. NO red/green styles
      }
    },

    validate: function () {
      var formData = {};
      Object.keys(this.form).forEach((fieldName) => {
        formData[fieldName] = this.form[fieldName].value;
      });

      // formData.imageFilename = this.imageFilename; // Need this to pass validation since imageFilename NOT in the this.form obj

      var message = Message.update(formData); // Validation here so, test if validation passed next...

      console.log('message data', message);
      this.formValid = Message.validationPassed();

      // Reset form field values to display latest 'state' of form after validation/sanitization/etc.
      Object.keys(message).forEach((fieldName) => {
        this.form[fieldName].value = message[fieldName].trim();
      });

      if (!this.formValid) {
        Message.validationErrors().forEach((err) => {
          var propName = Message.getErrorProp(err);
          // console.log('prop', propName);
          this.form[propName].valid = false; // Set to false to show validation state feedback of 'invalid', i.e. red styles
          this.form[propName].errorMsg = Message.getErrorMsg(err);
          // console.log(propName, Message.getErrorMsg(err));
        });
      }
      this.message = message;
    },

    doSend: async function () {
      // --------------- Validate form data
      this.validate();
      if (!this.formValid) return;

      // Handled via cf now
      var messageObj = {
        uid: this.authUser.uid,
        subject: this.message.subject,
        message: this.message.message,
        // createdAt: this.$fapi.firebase.firestore.FieldValue.serverTimestamp(),
      };

      this.processingMessage = true;
      try {
        await this.$fapi.firebase.functions().httpsCallable('inAppContact')(
          messageObj
        );
        this.resultType = 'success';
      } catch (err) {
        this.resultType = 'error';
        this.resultErrorMsg = 'Your message was not sent: ' + err.message;
      }

      this.processingMessage = false;
      this.showSendResult = true;
    },
  },
};
</script>

<style>
</style>